module.exports = __webpack_public_path__ + "static/106-ab26f4b00ef16517f23a43b74ee9b2d3.jpg";